import { useDispatch } from "react-redux";
import { setAlertModal } from "../store/actions/app";
import { noSpecialCharacters } from "../constants/messages";
import { containsSpecials } from "../store/actions/anonymousForms";

const useNoSpecialChars = () => {
  const dispatch = useDispatch();
  return (event) => {
    if (containsSpecials(event.target.value)) {
      dispatch(setAlertModal(true, "error", noSpecialCharacters));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 2000);
      return false;
    } else {
      dispatch(setAlertModal(false, ""));
      return true;
    }
  };
};

export default useNoSpecialChars;
